import PropTypes from 'prop-types';

export default PropTypes.exact({
  hasError: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  results: PropTypes.shape({
    callno: PropTypes.string.isRequired,
    library: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    maps: PropTypes.arrayOf(
      PropTypes.shape({
        directions: PropTypes.string,
        floorname: PropTypes.string,
        height: PropTypes.number,
        library: PropTypes.string,
        mapurl: PropTypes.string,
        ranges: PropTypes.arrayOf(
          PropTypes.shape({
            callnoDisplay: PropTypes.string,
            callnos: PropTypes.arrayOf(
              PropTypes.shape({
                start: PropTypes.string,
                end: PropTypes.string
              })
            ),
            coordinates: PropTypes.array,
            endcallno: PropTypes.string,
            label: PropTypes.string,
            rangename: PropTypes.string,
            rangeno: PropTypes.number,
            startcallno: PropTypes.string,
            x: PropTypes.number,
            y: PropTypes.number
          })
        ),
        width: PropTypes.number
      })
    )
  }),
  settings: PropTypes.shape({
    domain: PropTypes.string.isRequired,
    enabled: PropTypes.bool.isRequired,
    hideRanges: PropTypes.bool.isRequired,
    supportedBranches: PropTypes.arrayOf(PropTypes.string).isRequired
  })
});
